import { node, bool, string } from "prop-types";
import React, { forwardRef, useMemo } from "react";
import { twMerge } from "tailwind-merge";

import { useTextFormatter } from "@hooks/useTextFormatter";

const Typography = forwardRef((props, ref) => {
  const { className, children, withFormatter = true, ...restProps } = props;
  const formatText = useTextFormatter();

  const content = useMemo(
    () =>
      typeof children === "string" && withFormatter
        ? formatText(children)
        : children,
    [children, withFormatter]
  );

  return (
    <p
      className={twMerge(
        "text-black text-base text-left font-normal m-0",
        className
      )}
      {...restProps}
      ref={ref}
    >
      {content}
    </p>
  );
});

Typography.displayName = "Typography";

Typography.propTypes = {
  children: node.isRequired,
  className: string,
  withFormatter: bool,
};

export default Typography;
